import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import { Autocomplete, TextField, createFilterOptions } from "@mui/material";
import ClipLoader from "react-spinners/ClipLoader";
import axios from "axios";
import { useDebounce } from "use-debounce";
import { TextInputLabel } from "./EntityList.styled";
import UserInfo from "@utils/UserInfo";

const EntityList = (props) => {
  const {
    t,
    formData,
    setFormData,
    objectType,
    objectId,
    isEditMode,
    countryId,
  } = props;

  const [selectedEntity, setSelectedEntity] = useState([]);
  const [entityList, setEntityList] = useState([]);
  const [isEntitySuggestionsLoading, setEntitySuggestionsLoading] =
    useState(false);
  const [query, setQuery] = useState();
  const [debounceQuery] = useDebounce(query, 700);

  useEffect(() => {
    setFormData({
      ...formData,
      linkedEntities: {
        value: selectedEntity,
        error: "",
        required: true,
      },
    });
  }, [selectedEntity]);

  useEffect(() => {
    if (objectType !== "" && objectId !== "" && !isEditMode) {
      let url = `/general/search?objectId=${objectId}&limit=10&countries=[${countryId}]&objectTypes=["${objectType}"]`;
      getEntityData(url, "selectedDefault");
    }
    if (isEditMode) {
      let entityList = [];

      if (formData.linkedEntities?.value?.companies) {
        formData.linkedEntities?.value.companies.map((key) => {
          entityList.push({
            group: t("COMPANIES"),
            identity: "COMPANY",
            name: key.id + " - " + key.name,
            id: "company-" + key.id,
          });
        });
      }
      if (formData.linkedEntities?.value?.contacts) {
        formData.linkedEntities?.value.contacts.map((key) => {
          entityList.push({
            group: t("CONTACT"),
            identity: "CONTACT",
            name: key.id + " - " + key.name,
            id: "contact-" + key.id,
          });
        });
      }
      if (formData.linkedEntities?.value?.sites) {
        formData.linkedEntities?.value.sites.map((key) => {
          entityList.push({
            group: t("SITE"),
            identity: "SITE",
            name: key.id + " - " + key.name,
            id: "site-" + key.id,
          });
        });
      }
      setSelectedEntity(entityList);
    }
  }, []);

  const handleChange = (e) => {
    setQuery(e.target.value || undefined);
  };

  useEffect(() => {
    searchEntity();
  }, [debounceQuery]);

  const searchEntity = () => {
    const search = query;
    if (search) {
      let url = `/general/search?search=${search}&limit=10&countries=[${countryId}]&objectTypes=["company","contact","site"]`;
      getEntityData(url, "all");
    }
  };
  const getEntityData = (url, type) => {
    setEntitySuggestionsLoading(true);
    axios
      .get(url)
      .then((response) => {
        let entityGroupList = [];
        if (response?.data?.companies) {
          response.data.companies.map((key) => {
            entityGroupList.push({
              group: t("COMPANIES"),
              identity: "COMPANY",
              name: key.id + " - " + key.name,
              id: "company-" + key.id,
            });
          });
          if (
            type === "selectedDefault" &&
            response.data.companies.length === 1
          ) {
            setSelectedEntity([entityGroupList[0]]);
          }
        }
        if (response?.data?.contacts) {
          response.data.contacts.map((key) => {
            entityGroupList.push({
              group: t("CONTACT"),
              identity: "CONTACT",
              name: key.id + " - " + key.name,
              id: "contact-" + key.id,
            });
          });
          if (
            type === "selectedDefault" &&
            response.data.contacts.length === 1
          ) {
            setSelectedEntity([entityGroupList[0]]);
          }
        }
        if (response?.data?.sites) {
          response.data.sites.map((key) => {
            entityGroupList.push({
              group: t("SITE"),
              identity: "SITE",
              name: key.id + " - " + key.name,
              id: "site-" + key.id,
            });
          });
          if (type === "selectedDefault" && response.data.sites.length === 1) {
            setSelectedEntity([entityGroupList[0]]);
          }
        }
        setEntityList(entityGroupList);
        setEntitySuggestionsLoading(false);
      })
      .catch((error) => {
        if (window.debugMode) {
          console.error(
            "Error: an error occurred while fetching entities",
            error
          );
        }
        setEntityList([]);
        setEntitySuggestionsLoading(false);
      });
  };

  return (
    <>
      <TextInputLabel>
        {" "}
        {t("ENTITES_LINKED")}
        {isEntitySuggestionsLoading && (
          <ClipLoader size={15} background="#15aee5 !important" />
        )}
      </TextInputLabel>
      <Autocomplete
        multiple
        id="tags-outlined"
        options={entityList}
        groupBy={(option) => option.group}
        getOptionLabel={(option) => option.name}
        style={{ zIndex: 99 }}
        filterSelectedOptions
        renderOption={(props, option) => (
          <Box component="li" {...props} key={option.id}>
            {option.name}
          </Box>
        )}
        renderInput={(params) => <TextField {...params} placeholder="" />}
        value={selectedEntity}
        onKeyUp={handleChange}
        onChange={(event, newValue) => {
          // Check if 'All' option is clicked
          if (newValue.find((option) => option.id === 0)) {
            // Check if all options are selected
            if (usersOptions.length === selectedEntity.length) {
              setSelectedEntity([]);
            } else {
              setSelectedEntity(usersOptions);
            }
          } else {
            setSelectedEntity(newValue);
          }
        }}
        // Add These props
        isOptionEqualToValue={(option, value) => option.id === value.id}
        filterOptions={(options, params) => {
          const filtered = createFilterOptions()(options, params);
          return [...filtered];
        }}
      />
    </>
  );
};

EntityList.propTypes = {
  t: PropTypes.func.isRequired,
  isEditMode: PropTypes.bool,
};

EntityList.defaultProps = {
  isEditMode: false,
};
export default withTranslation()(EntityList);
